import React, { useState, useEffect, useRef} from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Camera from '../camera/Camera';
import ReactModal from 'react-modal';
import useTaskDetailsFormControlStore from '../stores/TaskDetailsFormControlStore';
import useTaskStore from '../stores/useTaskStore';
import { FaImages } from 'react-icons/fa';
import { toast } from "react-toastify";



export const WmPhotoBrief = props => {
    const [propState, setPropState] = useState(props);
    const [show, setShow] = useState(false);
    const [showGalleryConfirm, setShowGalleryConfirm] = useState(false);
    const galleryInputRef = useRef(null);
    const maxGalleryFileSizeMb = 10; // 10 MB
    const maxGalleryFileSize = maxGalleryFileSizeMb * 1024 * 1024; // 10 MB in bytes
    const allowedGalleryTypes = ["image/jpeg", "image/png"];

    const isMountedComponent = useRef(true);

    const isButtonDisabled = useTaskDetailsFormControlStore((state) => state.isButtonDisabled);
    const { selectedTask } = useTaskStore();

    useEffect(() => {
        if (isMountedComponent.current) {
            setPropState(props);
        }
        return () => {
             isMountedComponent.current = false; };
    }, [props]);


    const handleTakePhotoBasic = async (img, download = true) => {
      const curTask = selectedTask;
      const newState = Object.assign({}, propState.anyWorkList);
      const newStateActTask = newState[`${propState.actTask}`];
      let curImgList = newStateActTask.wmlist[propState.item].images;
      const imgFileName = `${curTask.work_no}-${curTask.task_no}-${propState.file_name_ext}${newStateActTask.imgSerial.toString().padStart(3, "0")}.jpg`;
      newStateActTask.imgSerial++;
      setShow(false);
      if (Array.isArray(curImgList) && curImgList.length > 0) {
        curImgList = [...curImgList, { name: imgFileName, image: img }];
      } else {
        curImgList = [{ name: imgFileName, image: img }];
      }
      newStateActTask.wmlist[propState.item].images = curImgList;

      propState.SetAnyWorkList(newState);

      // Don't force download, for example when the user uploads image from disk. No reason to redonwload it.
      if (download) {
        let link = document.createElement("a");
        link.href = img;
        link.download = imgFileName;
        link.click();
      }
    };;

    const handleGalleryConfirm = () => {
        setShowGalleryConfirm(false);
        galleryInputRef.current.click();
    };

    const handleGallerySelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!allowedGalleryTypes.includes(file.type)) {
          toast.error("Csak JPG vagy PNG formátum engedélyezett.");
          e.target.value = "";
          return;
        }
        if (file.size > maxGalleryFileSize) {
          toast.error(
            `A kiválasztott kép túl nagy. Maximum ${maxGalleryFileSizeMb} MB engedélyezett.`,
          );
          e.target.value = "";
          return;
        }
        const imgUrl = URL.createObjectURL(file);
        handleTakePhotoBasic(imgUrl, false);
        e.target.value = '';
    };

    return (
      <>
        {show && (
          <ReactModal
            isOpen={show}
            appElement={document.getElementById("root")}
            style={{
              width: "100%",
              height: "100%",
              margin: "0",
              padding: "0",
              dialog: {
                width: "100%",
                height: "100%",
                margin: "0",
                padding: "0",
              },
              content: {
                width: "100%",
                height: "auto",
                minHeight: "100%",
                inset: "0",
                borderRadius: "0",
                margin: "0",
                padding: "0",
              },
              // transform: 'translate(-50%, -50%)'
            }}
            contentLabel="Photo Modal"
          >
            <div>
              <div>
                <Camera onTakePhoto={handleTakePhotoBasic} />
              </div>
              <Button
                variant="success"
                onClick={() => setShow(false)}
                className="mt-1 mb-2 "
              >
                Kamera kikapcsol
              </Button>
            </div>
          </ReactModal>
        )}
        <Button
          variant="info"
          onClick={() => setShow(true)}
          className="ml-4 mb-2"
          disabled={isButtonDisabled}
        >
          Fotózás
        </Button>
        <Button
          variant="secondary"
          onClick={() => setShowGalleryConfirm(true)}
          className="ml-2 mb-2"
          disabled={isButtonDisabled}
          title="Feltöltés galériából"
        >
          <FaImages />
        </Button>
        <input
          type="file"
          accept="image/jpeg,image/png"
          ref={galleryInputRef}
          style={{ display: "none" }}
          onChange={handleGallerySelect}
        />
        <Modal
          animation={false}
          show={showGalleryConfirm}
          onHide={() => setShowGalleryConfirm(false)}
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Galéria feltöltés</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Biztos, hogy egy korábbi fényképet szeretne feltölteni?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowGalleryConfirm(false)}
            >
              Mégsem
            </Button>
            <Button variant="primary" onClick={handleGalleryConfirm}>
              Igen
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
}
